import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import ic_close from "image/ic_close.svg";
import ic_menu from "image/ic_menu.svg";

import firebase from "library/firebase-config.js";
import "firebase/firestore";
import { authContext } from "shared/App";
var db = firebase.firestore();

const LINK_SHOP = "https://www.donggubat.co.kr/";

const Header = (props) => {
	const { setIsLogoLoading, isDetail } = useContext(authContext);

	// logo
	const [logoURL, setLogoUrl] = useState();

	const _getLogoUrl = async () => {
		let result = null;
		const ref = await db.collection("home").doc("logos").get();
		ref.data().items.forEach((element) => {
			if (element.label === "헤더 로고") {
				result = element.contents[0].url;
			}
		});
		return result;
	};

	useEffect(() => {
		const init = async () => {
			setIsLogoLoading(true);
			setLogoUrl(await _getLogoUrl());
			setIsLogoLoading(false);
		};
		init();
	}, [setIsLogoLoading]);

	return (
		<header className={props.showHeader || isDetail ? "header-type-main" : ""}>
			<div className="con">
				<Link to="/" className={`header-logo ${!logoURL ? `hide` : ""}`}>
					<img src={logoURL} alt="logo" />
				</Link>

				<div className="header-left wrap-gnb-pc">
					<ul className="header-gnb font-gnb">
						<li>
							<Link to="/about">about us</Link>

							<ul className="wrap-lnb">
								<li>
									<Link to="/about/media">media</Link>
								</li>
							</ul>
						</li>
						<li>
							<Link to="/service">services</Link>
						</li>
						<li>
							<Link to="/portfolio">portfolio</Link>
						</li>
						<li>
							<a target={"_blank"} href="https://mysterious-cloche-461.notion.site/7d7503ab9c0947aab41c805ac21d970f">
								recruit
							</a>
							{/* <Link to="/recruit">recruit</Link> */}

							{/* <ul className="wrap-lnb">
								<li>
									<Link to="/recruit/staff">가꿈지기 채용</Link>
								</li>
								<li>
									<Link to="/recruit/manager">직원 채용</Link>
								</li>
							</ul> */}
						</li>
						<li>
							<Link to="/customer">customer center</Link>
							{/* 
							<ul className="wrap-lnb">
								<li>
									<Link to="/customer/notice">공지사항</Link>
								</li>
								<li>
									<Link to="/customer/qna">묻고 답하기 </Link>
								</li>
							</ul> */}
						</li>
					</ul>

					<div className="btn-shop">
						<a href={LINK_SHOP} target="_blank" rel="noopener noreferrer">
							shop
						</a>
					</div>
				</div>

				<div className="wrap-gnb-mobile" onClick={props.menuClickHandler}>
					<img className="ic-menu" src={props.isMenuClicked ? ic_close : ic_menu} alt="menu" />
				</div>
			</div>
		</header>
	);
};

export default Header;
